import { Inset, Text } from '@doordash/design-language';
export var Sizes = {
  Small: 'SMALL',
  Large: 'LARGE'
};
export var Sides = {
  Start: 'START',
  End: 'END'
};
export var CellStyles = {
  SmallToggled: {
    title: Text.Styles.ListRowTitleSelected,
    subtext: Text.Styles.ListRowSubtextSelected,
    secondaryTitle: Text.Styles.ListRowSecondarySelected
  },
  Small: {
    title: Text.Styles.ListRowTitle,
    subtext: Text.Styles.ListRowSubtext,
    secondaryTitle: Text.Styles.ListRowSecondary
  },
  LargeToggled: {
    title: Text.Styles.ListRowTitleLargeSelected,
    subtext: Text.Styles.ListRowSubtextLargeSelected,
    secondaryTitle: Text.Styles.ListRowSecondaryLargeSelected
  },
  Large: {
    title: Text.Styles.ListRowTitleLarge,
    subtext: Text.Styles.ListRowSubtextLarge,
    secondaryTitle: Text.Styles.ListRowSecondaryLarge
  }
};
export var CONTENT_ROW = 2;
export var CELL_PADDING = Inset.Sizes.Small;